// 横スクロールプログレスバー
export default class HorizonScroll{
  constructor(){
    this.target =  Array.from(document.getElementsByClassName('js-hrScrollbar'));

    if(this.target){
      this.init();
    }
  }

  init(){
    this.target.forEach(elm => {
      let contentObj = elm.firstElementChild;
      let contentWidth = contentObj.scrollWidth;
      let winWidth = window.innerWidth;
      if(winWidth > 600){
        winWidth = 750;
        return;
      }
      let scrollArea = winWidth * 360 / 375;
      let maxScroll = contentWidth - scrollArea;
      if(maxScroll > 0){
        let barHtml = document.createElement('div');
        barHtml.classList.add('js-hrScrollbar-track','hrScrollbar-track');
        barHtml.innerHTML = '<span class="js-hrScrollbar-indicator hrScrollbar-indicator"></span>';
        if(!elm.querySelector('.js-hrScrollbar-indicator')){
          elm.appendChild(barHtml);
        }
        elm.firstElementChild.style.width = contentWidth + 'px';
        elm.firstElementChild.style.marginBottom = '20px';
        // console.log(elm);
        elm.addEventListener('scroll', function(){
          let bar = elm.querySelector('.js-hrScrollbar-indicator');
          let barTranslateX = elm.scrollLeft / maxScroll;
          barTranslateX = barTranslateX * 200;
          barTranslateX = Math.trunc(barTranslateX);
          bar.style.transform = 'translateX(' + barTranslateX + '%)';
        });
      }
    });
  }

}

window.addEventListener('load', function(){
  if(window.innerWidth < 600){
    new HorizonScroll();
  }
});
let currentWidth = window.innerWidth;
window.addEventListener('resize',function(){
  if (currentWidth == window.innerWidth) {
    // ウインドウ横幅が変わっていないため処理をキャンセル。
    return;
  }
  // 横幅を更新
  currentWidth = window.innerWidth;
  if(window.innerWidth < 600){
    new HorizonScroll();
  }
});
document.body.addEventListener('loadMore',function(){
  if(window.innerWidth < 600){
    new HorizonScroll();
  }
});
document.body.addEventListener('rtCalled',function(){
  if(window.innerWidth < 600){
    new HorizonScroll();
  }
});

